<template>
  <div class="home">
    <div  class="container">
      <Navbar />
      <Banner />
      <About id="about" />
      <Value id="value" />
      <Contact id="contact" />
      <Twitter />
      <Instagram />  
      <Footer />
    </div>
  </div>
</template>

<script>
import Navbar from '@/components/Navigation';
import Banner from '@/components/Banner';
import About from '@/components/About';
import Value from '@/components/Value';
import Contact from '@/components/Contact';
import Twitter from '@/components/Twitter';
import Instagram from '@/components/Instagram';
import Footer from '@/components/Footer';

export default {
  name: 'Home',
  components: {
    Navbar,
    Banner,
    About,
    Value,
    Contact,
    Twitter,
    Instagram,
    Footer
  },
  data(){
    return{
      login: 0,
      focusedElement: null,
      roleAdmin: "mzLfUNRL46",
      roleUser: "6Wk2ojqf4D",
      progress: 0
    }
  },
  mounted(){

    const user = this.$parse.User.current()
    
    if(user){
      if(user.attributes.role.id == this.roleAdmin){
        this.$router.push('/admin')
      } else if( user.attributes.role.id == this.roleUser){
        this.$router.push('/feed')
      } else {
        this.error = "Usuario no registrado"
      }
    }
  },
  beforeMount() {

    localStorage.login = this.login;
    
    //if (this.progress == 0) {
      //this.progress = 1;
      //setInterval(this.frame, 10);  
    //}
  },
  methods:{
  }
}
</script>